module.exports = __webpack_public_path__ + "media/honey-icons/icon-view-outdoor-8a878985.svg";